import React from "react";
import Icon from "./Icon";
export default function Record(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1667C16.0627 20.1667 20.1667 16.0626 20.1667 11C20.1667 5.93739 16.0627 1.83333 11 1.83333C5.93743 1.83333 1.83337 5.93739 1.83337 11C1.83337 16.0626 5.93743 20.1667 11 20.1667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z"
  }));
}
Record.displayname = "Record";
//# sourceMappingURL=Record.js.map